import moment from "moment";
import {Templates} from "./Transfers/Templates";

export const dateFormatter = (date=new Date(), format="DD.MM.YYYY HH:mm", coming_format='DD.MM.YYYY HH:mm') => {
    return moment(date, coming_format).format(format);
}

export const generateGuid = () => {
    let dt = new Date().getTime();
    const guid = 'xxxxxxxx-xxxx-xxxx-xxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
        const r = (dt + Math.random() * 16) % 16 | 0;
        dt = Math.floor(dt / 16);
        return (c === 'x' ? r : (r & 0x3 | 0x8)).toString(16);
    });
    return guid;
}

export const financialExchange = (get_val : any, germanFormat : boolean =false) => {
    let original_val=get_val?.toString().replace(/\s/g, '');

    if (!isNaN(original_val)){

        let val=Number.parseFloat(original_val);

        let num = val.toString().includes('.') ? val.toString().split('.')[0] : val.toString();
        let len = num.toString().length;
        let result = '';
        let count = 1;

        for (let i = len - 1; i >= 0; i--) {
            result = num.toString()[i] + result;
            if (count % 3 === 0 && count !== 0 && i !== 0) {
                result = ' ' + result;
            }
            count++;
        }

        // return the number with decimal point if it exists

        let standard_val=val.toString().includes('.') ? (result + '.' + val.toString().split('.')[1]) : result;

        if(standard_val.charAt(0) === "-" && standard_val.charAt(1) === " "){
            standard_val = standard_val.replace(" ", "");
        }

        let get_german_format=new Intl.NumberFormat('de-DE', { minimumFractionDigits: 4, maximumFractionDigits: 4 }).format(Number.parseFloat(original_val).toFixed(4));

        return germanFormat ? get_german_format.replace(',', '.')  : standard_val;

    }

}

export const financial = (get_val : any, germanFormat : boolean =false) => {
    let original_val=get_val?.toString().replace(/\s/g, '');

    if (!isNaN(original_val)){


        let val=Number.parseFloat(original_val).toFixed(2);

        let num = val.toString().includes('.') ? val.toString().split('.')[0] : val.toString();
        let len = num.toString().length;
        let result = '';
        let count = 1;

        for (let i = len - 1; i >= 0; i--) {
            result = num.toString()[i] + result;
            if (count % 3 === 0 && count !== 0 && i !== 0) {
                result = ' ' + result;
            }
            count++;
        }

        // return the number with decimal point if it exists

        let standard_val=val.toString().includes('.') ? (result + '.' + val.toString().split('.')[1]) : result;

        if(standard_val.charAt(0) === "-" && standard_val.charAt(1) === " "){
            standard_val = standard_val.replace(" ", "");
        }
        
        let get_german_format=new Intl.NumberFormat('de-DE', { minimumFractionDigits: 4, maximumFractionDigits: 4 }).format(Number.parseFloat(original_val).toFixed(4));

        return germanFormat ? get_german_format.replace(',', '.')  : (standard_val === undefined || standard_val === null ? "" : standard_val);

    }


}

export const checkAmountForRequest = (amount : number) => {
    return parseFloat(amount?.toString()?.replace(/\s/g, ''))?.toFixed(2);
}

export const roundSalaryAmount = (value : any) => {
    if (value === null || value === undefined || value === '') return value
    const normalized = value.toString().replace(/\s/g, '').replace(',', '.')
    if (normalized === '' || isNaN(Number(normalized))) return value

    const negative = normalized.trim().startsWith('-')
    const [intPart, fracPartRaw = ''] = normalized.replace('-', '').split('.')
    const frac = fracPartRaw.padEnd(3, '0')

    let cents = Number(intPart) * 100 + Number(frac.slice(0, 2))

    if (Number(frac[2]) >= 5) cents += 1

    const result = (cents / 100).toFixed(2)
    return negative ? `-${result}` : result
}

export const convertAmountFormatForRequest = (amount : any) => {
    const formatter = new Intl.NumberFormat('en-US', { style: 'decimal',  minimumFractionDigits: 2, useGrouping: true });
    const formattedNumber = formatter.format(amount).replaceAll(',', ' ');
    return formattedNumber
}

export const addStr = (str : string, index : number = 29, stringToAdd : string='...') =>{
    let convert_str = String(str).toString();
    let startCount = index / 2;
    let endCount = index - startCount;
    let startEndIndex = convert_str.length - endCount;
    return (convert_str.length > index ) ? convert_str.substring(0, startCount) + stringToAdd + convert_str.substring(startEndIndex, convert_str.length) : convert_str;
}

export const addStrAccountOperation = (str : string, index : number = 29, stringToAdd : string='...') =>{
    let convert_str = String(str).toString();
    let startCount = index / 2;
    let endCount = index - startCount;
    let startEndIndex = convert_str.length - endCount;
    return (convert_str.length > index ) ? convert_str.substring(0, startCount) + convert_str.substring(startEndIndex, convert_str.length) + stringToAdd : convert_str;
}

export const resetForm = (form : any) => {
    form.resetFields();
}

export const getPathnameByIndex : any = (index : number) => {
    const split=window.location.pathname.replace('/', '').split('/');

    return split[index] ?? false;
}

export const convertBase64 = (file: any) => {
    return new Promise((resolve, reject) => {
        const fileReader = new FileReader()
        fileReader.readAsDataURL(file)
        fileReader.onload = () => {
            resolve(fileReader?.result)
        }
        fileReader.onerror = (error) => {
            reject(error)
        }
    })
}

export const fillCurrentForm = async (currentForm : any, trnData : any) => {
    console.log("frm",trnData);
    
    await currentForm.validateFields().then(success_input_list => {

        fillInputValues(success_input_list, currentForm, trnData)

    }).catch(err_input_list => {
        let values= err_input_list.values

        fillInputValues(values, currentForm, trnData)

    });
}

export const fillCurrentFormTemplate = async (currentForm : any, trnData : any) => {

    await currentForm.validateFields().then(success_input_list => {

        fillInputValuesTemplate(success_input_list, currentForm, trnData)

    }).catch(err_input_list => {
        let values= err_input_list.values

        fillInputValuesTemplate(values, currentForm, trnData)

    });
}



export const fillInputValues = (form_data : any, currentForm : any, trnData : any) => {
    for(let input_name in form_data){
        if(input_name !== 'AMOUNT') {
            currentForm.setFieldsValue({
                [input_name]: trnData[input_name] ?? ''
            });
        } else {
            let value1 = trnData[input_name] !== '' && trnData[input_name] !== undefined ? checkAmountForRequest(trnData[input_name]) : trnData[input_name];
            currentForm.setFieldsValue({
                [input_name]: value1 ?? ''
            });
        }
    }
}

export const fillInputValuesTemplate = (form_data : any, currentForm : any, trnData : any) => {
    for(let input_name in form_data) {
        if (input_name !== 'PMTCUSTID') {
            if(input_name !== 'AMOUNT') {
                currentForm.setFieldsValue({
                    [input_name]: trnData[input_name] ?? ''
                });
            } else {
                let value1 = trnData[input_name] !== '' && trnData[input_name] !== undefined ? checkAmountForRequest(trnData[input_name]) : trnData[input_name];
                currentForm.setFieldsValue({
                    [input_name]: value1 ?? ''
                });
            }
        }
    }
}


export const dateFormatterForBlock = (date=new Date(), format="YYYY-MM-DD HH:mm", coming_format='DD.MM.YYYY') => {
    return moment(date, coming_format).format(format);
}

export function removeEmojiCodes(str:any) {
    if(str){
        const regex = /(?:[\u2700-\u27bf]|(?:\ud83c[\udde6-\uddff]){1,2}|[\ud800-\udbff][\udc00-\udfff]|[\u0023-\u0039]\ufe0f?\u20e3|\u3299|\u3297|\u303d|\u3030|\u24c2|\ud83c[\udd70-\udd71]|\ud83c[\udd7e-\udd7f]|\ud83c\udd8e|\ud83c[\udd91-\udd9a]|\ud83c[\udde6-\uddff]|\ud83c[\ude01-\ude02]|\ud83c\ude1a|\ud83c\ude2f|\ud83c[\ude32-\ude3a]|\ud83c[\ude50-\ude51]|\u203c|\u2049|[\u25aa-\u25ab]|\u25b6|\u25c0|[\u25fb-\u25fe]|\ud83c[\uDF00-\uDFFF]|\ud83d[\udc00-\ude4f]|\ud83d[\ude80-\udeff]|\ud7c9[\ude00-\udeff]|\ud83e[\udd10-\uddff])/g;
        const newStr = str?.replace(regex, '');
        const finalStr = newStr.replace(/&#[0-9]+;/g, '');
        return finalStr;
    }else{
        return str
    }
  }